module.exports = __webpack_public_path__ + "static/search-phone-28ae3b99ad63fea4e520b1750183c1c5.jpg";